import React from "react";

const TodaySection = () => {
  const today = new Date().getDate(); // e.g. 8

  return (
    <div className="w-36 h-10 rounded-md border border-zinc-500 flex items-center justify-center text-sm text-zinc-500 font-['Inter'] gap-2">
      {/* Align icon to top edge of text */}
      <div className="flex items-start pt-[2px]">
        <div className="w-4 h-5 relative">
          {/* Top rings */}
          <div className="w-0 h-0.5 left-[5.33px] top-[1px] absolute outline outline-[1.3px] outline-offset-[-0.65px] outline-zinc-500" />
          <div className="w-0 h-0.5 left-[10.67px] top-[1px] absolute outline outline-[1.3px] outline-offset-[-0.65px] outline-zinc-500" />

          {/* Outer box */}
          <div className="w-3 h-[12px] left-[2px] top-[2px] absolute outline outline-[1.3px] outline-offset-[-0.65px] outline-zinc-500 rounded-sm" />

          {/* Horizontal mid-line */}
          <div className="w-3 h-0 left-[2.17px] top-[10.5px] absolute outline outline-[1.3px] outline-offset-[-0.65px] outline-zinc-500" />

          {/* Date number */}
          <div className="w-3 h-[10px] left-[2px] top-[2px] absolute flex items-center justify-center text-[10px] font-bold text-zinc-500">
            {today}
          </div>
        </div>
      </div>

      Today
    </div>
  );
};

export default TodaySection;
